import { trackInteraction } from './analytics';
import { getReservableAvailability } from './availability';

export async function showNotificationCard() {
  const notification = JSON.parse(localStorage.getItem('notification'));
  const containerSelector = '.notification-card-container';
  const container = document.querySelector(containerSelector);

  // env comes in as string (casting string 'false' to Boolean still returns true)
  if (notification && container) {
    const { showNotification } = notification || {};
    const cardSelector = 'a.notification-card';
    const imgSelector = 'img';
    const productDescriptionSelector = '.selection-card-product-description';
    const buildingNameSelector = '.notification-card-building-name';
    const alertSelector = '.wework-page-alert';

    if (showNotification && !doNotShow()) {
      // check availability if we are showing component
      const isAvailable = await getReservableAvailability(notification.id);
      if (isAvailable) {
        const isAlertBanner = document.querySelector(alertSelector);
        const card = container.querySelector(cardSelector);

        if (isAlertBanner) {
          if (!isAlertBanner.className.includes('hidden')) {
            card.className = 'notification-card--alert';
          }
        }

        container.className = 'notification-card-container';
        const image = container.querySelector(imgSelector);
        const productDescription = container.querySelector(productDescriptionSelector);
        const buildingName = container.querySelector(buildingNameSelector);

        card.setAttribute('href', notification.deepLink);
        card.setAttribute('aria-label', notification.displayType);
        const imageProps = '?auto=format%20compress&fit=crop&q=50&w=164&h=164';
        image.setAttribute('src', `${notification.officePhoto}${imageProps}`);

        productDescription.innerText = `${notification.displayType} #${notification.unit}`;

        const { name } = notification || {};
        if (name) {
          buildingName.innerText = `${name}`;
        }

        trackInteraction({
          label: 'PUWYLO - show notification'
        });

        container.addEventListener('click', e => {
          if (e.target.closest('.notification-close-btn-container')) {
            hideNotification();
            e.preventDefault();
            container.style.animation = 'fade-out 0.25s ease-out both';
            trackInteraction({
              label: 'PUWYLO - close notification'
            });
            container.removeEventListener();
          } else {
            e.preventDefault();

            if (e.target.closest('.selection-card-product-info-container')) {
              trackInteraction({
                label: 'PUWYLO - click on notification'
              });

              hideNotification();
              container.removeEventListener();
              window.location.href = notification.deepLink;
            }
          }
        });

        // account for alert banner height
        document.addEventListener('click', e => {
          if (e.target.closest('.wework-page-alert-exit')) {
            card.className = 'notification-card';
          }
        });

        window.addEventListener('scroll', () => {
          const lastKnownScrollPosition = window.scrollY;
          let ticking;
          let offsetY = 86;

          if (!isAlertBanner.className.includes('hidden')) {
            offsetY = 126;
          }

          if (!ticking) {
            window.requestAnimationFrame(() => {
              if (lastKnownScrollPosition > offsetY) {
                card.className = 'notification-card--fixed';
              } else if (!isAlertBanner.className.includes('hidden')) {
                card.className = 'notification-card--alert';
              } else {
                card.className = 'notification-card';
              }
              ticking = false;
            });

            ticking = true;
          }
        });
      } else {
        const hideContainer = document.querySelector(containerSelector);
        if (hideContainer) {
          hideContainer.className = 'notification-card-container hidden';
        }
      }
    }
  }
}

function hideNotification() {
  const notification = JSON.parse(localStorage.getItem('notification'));
  if (notification) {
    localStorage.setItem('notification', JSON.stringify({ ...notification, showNotification: false }));
  }
}

function doNotShow() {
  return window.location.href.includes('reserve') || window.location.href.includes('search');
}
